import { createFileRoute } from '@tanstack/react-router'
import { MonitorDetailView } from '@/components/monitor-detail'

export const Route = createFileRoute('/_authenticated/dashboard/browser-checks/$id')({
  component: BrowserCheckDetailPage,
})

function BrowserCheckDetailPage() {
  const { id } = Route.useParams()
  return <MonitorDetailView id={id} section="browser" />
}
